<template>
  <div>
    <PassChoice :normalProducts="normalProducts" :aahProducts="aahProducts">
      <template #title>
        <h2>Le Pass <colored-name /></h2>
      </template>

      <template #description>
        <div>
          <img src="/assets/icons/paiement/illimite.png" />
          Je peux lire et envoyer un nombre <strong>ILLIMITÉ</strong> de messages sur <colored-name />!
        </div>
        <div>
          <img src="/assets/icons/paiement/message.png" />
          <strong> TOUS LES MEMBRES d'</strong><colored-name /> peuvent me lire et me répondre
          <strong>GRATUITEMENT</strong>!
        </div>
      </template>
    </PassChoice>
  </div>
</template>

<script>
import BasePage from "@/components/pages/BasePage";
import { idyuJsonRpc } from "@/assets/js/idyu/connect.js";
import PassChoice from "../pass/PassChoice.vue";
import ColoredName from "@/components/util/ColoredName";

export default {
  extends: BasePage,
  name: "Pass",
  components: { PassChoice, ColoredName },

  data() {
    return {
      normalProducts: null,
      aahProducts: null,
      selectedProduct: null,
      aah: false
    };
  },

  methods: {
    init: async function() {
      this.normalProducts = await idyuJsonRpc("getPassInformation");
      this.aahProducts = await idyuJsonRpc("getAAHPassInformation");
    }
  }
};
</script>

<style scoped lang="scss"></style>
